import { render, staticRenderFns } from "./CourseDetailsTab.vue?vue&type=template&id=7df0219d&scoped=true&"
import script from "./CourseDetailsTab.vue?vue&type=script&lang=js&"
export * from "./CourseDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df0219d",
  null
  
)

export default component.exports